/**
 * Full-page redirects to the centralized server auth UI (/auth/* → API).
 * Do not use Angular Router for these — the SPA must unload.
 */

const HIDE_LOGIN_STORAGE_KEY = 'ashcorp_iptv_hide_login';

function sanitizeReturnPath(path?: string | null): string {
    if (!path || typeof path !== 'string') {
        return '/';
    }

    const trimmed = path.trim();
    if (!trimmed.startsWith('/') || trimmed.startsWith('//') || trimmed.includes('://')) {
        return '/';
    }

    if (trimmed.startsWith('/auth') || trimmed.startsWith('/sign-in') || trimmed.startsWith('/sign-out')) {
        return '/';
    }

    return trimmed;
}

function hideLoginEnabled(): boolean {
    try {
        return sessionStorage.getItem(HIDE_LOGIN_STORAGE_KEY) === '1';
    } catch {
        return false;
    }
}

/** Navigate to server sign-in. Returns false for use in guard Observables. */
export function redirectToServerSignIn(returnPath?: string | null): false {
    const redirect = sanitizeReturnPath(returnPath);
    if (hideLoginEnabled()) {
        window.location.assign(redirect || '/');
        return false;
    }
    const url = redirect && redirect !== '/'
        ? `/auth/sign-in?redirect=${encodeURIComponent(redirect)}`
        : '/auth/sign-in';
    window.location.assign(url);
    return false;
}

/** Navigate to server sign-out page (clears session UI + redirects to sign-in). */
export function redirectToServerSignOut(): false {
    window.location.assign('/auth/sign-out');
    return false;
}
